import { TIME } from "../Dates";
import { CallbackManager } from "./CallbackManager";
import { CallbackManagerTimer } from "./CallbackManagerTimer";
import { CallbackManagerTimerEx } from "./CallbackManagerTimerEx";


/**
 * Callback class
 */
class Callback {

    config = new CallbackManager("config");
    
    // create callback
    configFinish = new CallbackManager("configFinish");
    // register callbacks
    onConfigFinish = (callback: Function) => {
        this.configFinish.register(callback);
    }

    // create callback
    explorerClose = new CallbackManager("explorerClose");
    // register callbacks
    onExplorerClose = (callback: Function) => {
        this.explorerClose.register(callback);
    }
    
    // create callback
    blogClick = new CallbackManager("blogClick");
    // register callbacks
    onBlogClick = (callback: Function) => {
        this.blogClick.register(callback);
    }

    // create callback
    browserClose = new CallbackManager("browserClose");
    // register callbacks
    onBrowserClose = (callback: Function) => {
        this.browserClose.register(callback);
    }

    // create callback
    buttonBackClick = new CallbackManager("buttonBackClick");
    // register callbacks
    onButtonBackClick = (callback: Function) => {
        this.buttonBackClick.register(callback);
    }


    // create callback
    seeAllConversationsClick = new CallbackManager("seeAllConversationsClick");
    // register callbacks
    onSeeAllConversationsClick = (callback: Function) => {
        this.seeAllConversationsClick.register(callback);
    }


    // create callback
    homeBodyScroll = new CallbackManager("homeBodyScroll");
    // register callbacks
    onHomeBodyScroll = (callback: Function) => {
        this.homeBodyScroll.register(callback);
    }



    // create callback
    updateAppState = new CallbackManager("updateAppState");
    // register callbacks
    onUpdateAppState = (callback: Function) => {
        this.updateAppState.register(callback);
    }


    // create callback
    messageSend = new CallbackManager("messageSend");
    // register callbacks
    onMessageSend = (callback: Function) => {
        this.messageSend.register(callback);
    }


    // create callback
    setChatHeaderSmall = new CallbackManager("setChatHeaderSmall");
    // register callbacks
    onSetChatHeaderSmall = (callback: Function) => {
        this.setChatHeaderSmall.register(callback);
    }


    // create callback
    conversation = new CallbackManager("conversation");
    // register callbacks
    onConversation = (callback: Function) => {
        this.conversation.register(callback);
    }


    // create callback
    messageNotify = new CallbackManager("messageNotify");
    // register callbacks
    onMessageNotify = (callback: Function) => {
        this.messageNotify.register(callback);
    }


    // create callback
    messageText = new CallbackManager("messageText");
    // register callbacks
    onMessageText = (callback: Function) => {
        this.messageText.register(callback);
    }



    // create callback
    chatInputSubmit = new CallbackManager("chatInputSubmit");
    // register callbacks
    onChatInputSubmit = (callback: Function) => {
        return this.chatInputSubmit.register(callback);
    }

    // create callback
    chatMessage = new CallbackManager("chatMessage");
    // register callbacks
    onChatMessage = (callback: Function) => {
        return this.chatMessage.register(callback);
    }

    // create callback
    chatState = new CallbackManager("chatState");
    // register callbacks
    onChatState = (callback: Function) => {
        return this.chatState.register(callback);
    }

    // create callback
    startNewChat = new CallbackManager("startNewChat");
    // register callbacks
    onStartNewChat = (callback: Function) => {
        return this.startNewChat.register(callback);
    }

    // create callback
    continueConversation = new CallbackManager("continueConversation", false);
    // register callbacks
    onContinueConversation = (callback: Function) => {
        return this.continueConversation.register(callback);
    }

    // create callback
    userOption = new CallbackManager("userOption");
    // register callbacks
    onUserOption = (callback: Function) => {
        return this.userOption.register(callback);
    }

    // create callback
    messageReceive = new CallbackManager("messageReceive");
    // register callbacks
    onMessageReceive = (callback: Function) => {
        return this.messageReceive.register(callback);
    }

    // create callback
    inputText = new CallbackManager("inputText", false);
    // register callbacks
    onInputText = (callback: Function) => {
        return this.inputText.register(callback);
    }

    // create callback
    inputEmail = new CallbackManager("inputEmail", false);
    // register callbacks
    onInputEmail = (callback: Function) => {
        return this.inputEmail.register(callback);
    }

    // create callback
    inputTerms = new CallbackManager("inputTerms", false);
    // register callbacks
    onInputTerms = (callback: Function) => {
        return this.inputTerms.register(callback);
    }

    // create callback
    formUpdate = new CallbackManager("formUpdate");
    // register callbacks
    onFormUpdate = (callback: Function) => {
        return this.formUpdate.register(callback);
    }

    // create callback
    msgUpdate = new CallbackManager("msgUpdate");
    // register callbacks
    onMsgUpdate = (callback: Function) => {
        return this.msgUpdate.register(callback);
    }

    // create callback
    formSubmit = new CallbackManager("formSubmit");
    // register callbacks
    onFormSubmit = (callback: Function) => {
        return this.formSubmit.register(callback);
    }


    // create callback
    removeListener = new CallbackManager("removeListener");
    // register callbacks
    onRemoveListener = (callback: Function) => {
        return this.removeListener.register(callback);
    }

    // create callback
    scrollToBottomChat = new CallbackManager("scrollToBottomChat");
    // register callbacks
    onScrollToBottomChat = (callback: Function) => {
        return this.scrollToBottomChat.register(callback);
    }

    // create callback
    focusChatInput = new CallbackManager("focusChatInput");
    // register callbacks
    onFocusChatInput = (callback: Function) => {
        return this.focusChatInput.register(callback);
    }

    // create callback
    blurChatInput = new CallbackManager("blurChatInput");
    // register callbacks
    onBlurChatInput = (callback: Function) => {
        return this.blurChatInput.register(callback);
    }

    // create callback
    appendChatInput = new CallbackManager("appendChatInput");
    // register callbacks
    onAppendChatInput = (callback: Function) => {
        return this.appendChatInput.register(callback);
    }

    // create callback
    botResponse = new CallbackManager("botResponse");
    // register callbacks
    onBotResponse = (callback: Function) => {
        return this.botResponse.register(callback);
    }

    // create callback
    disableChatInputs = new CallbackManager("disableChatInputs");
    // register callbacks
    onDisableChatInputs = (callback: Function) => {
        return this.disableChatInputs.register(callback);
    }

    // create callback
    enableChatInputs = new CallbackManager("enableChatInputs");
    // register callbacks
    onEnableChatInputs = (callback: Function) => {
        return this.enableChatInputs.register(callback);
    }

    // create callback
    resetChatInputs = new CallbackManager("resetChatInputs");
    // register callbacks
    onResetChatInputs = (callback: Function) => {
        return this.resetChatInputs.register(callback);
    }

    // create callback
    chatSendButton = new CallbackManager("chatSendButton");
    // register callbacks
    onChatSendButton = (callback: Function) => {
        return this.chatSendButton.register(callback);
    }

    // create callback
    chatSendButtonClick = new CallbackManager("chatSendButtonClick");
    // register callbacks
    onChatSendButtonClick = (callback: Function) => {
        return this.chatSendButtonClick.register(callback);
    }

    // create callback
    fileUploadClick = new CallbackManager("fileUploadClick");
    // register callbacks
    onFileUploadClick = (callback: Function) => {
        return this.fileUploadClick.register(callback);
    }

    // create callback
    fileUpload = new CallbackManager("fileUpload");
    // register callbacks
    onFileUpload = (callback: Function) => {
        return this.fileUpload.register(callback);
    }

    // create callback
    fileUploadUpdate = new CallbackManager("fileUploadUpdate");
    // register callbacks
    onFileUploadUpdate = (callback: Function) => {
        return this.fileUploadUpdate.register(callback);
    }

    // create callback
    userNotification = new CallbackManager("userNotification");
    // register callbacks
    onUserNotification = (callback: Function) => {
        return this.userNotification.register(callback);
    }

    // create callback
    userNotificationClose = new CallbackManager("userNotificationClose");
    // register callbacks
    onUserNotificationClose = (callback: Function) => {
        return this.userNotificationClose.register(callback);
    }

    // create callback
    emojiWindow = new CallbackManager("emojiWindow");
    // register callbacks
    onEmojiWindow = (callback: Function) => {
        return this.emojiWindow.register(callback);
    }

    // create callback
    collectionClick = new CallbackManager("collectionClick");
    // register callbacks
    onCollectionClick = (callback: Function) => {
        return this.collectionClick.register(callback);
    }

    // create callback
    hideCollections = new CallbackManager("hideCollections");
    // register callbacks
    onHideCollections = (callback: Function) => {
        return this.hideCollections.register(callback);
    }

    // create callback
    articleClick = new CallbackManager("articleClick");
    // register callbacks
    onArticleClick = (callback: Function) => {
        return this.articleClick.register(callback);
    }

    // create callback
    fileDragOver = new CallbackManager("fileDragOver");
    // register callbacks
    onfileDragOver = (callback: Function) => {
        return this.fileDragOver.register(callback);
    }

    // create callback
    fileDrop = new CallbackManager("fileDrop");
    // register callbacks
    onFileDrop = (callback: Function) => {
        return this.fileDrop.register(callback);
    }

    // create callback
    unreadMsgs = new CallbackManager("unreadMsgs");
    // register callbacks
    onUnreadMsgs = (callback: Function) => {
        return this.unreadMsgs.register(callback);
    }
    
    // create callback
    msgForm = new CallbackManager("msgForm");
    // register callbacks
    onMsgForm = (callback: Function) => {
        return this.msgForm.register(callback);
    }

    // create callback
    chatMsgReceive = new CallbackManager("chatMsgReceive");
    // register callbacks
    onChatMsgReceive = (callback: Function) => {
        return this.chatMsgReceive.register(callback);
    }

    // create callback
    userResponse = new CallbackManager("userResponse");
    // register callbacks
    onUserResponse = (callback: Function) => {
        return this.userResponse.register(callback);
    }

    // create callback
    chatId = new CallbackManager("chatId");
    // register callbacks
    onChatId = (callback: Function) => {
        return this.chatId.register(callback);
    }


    // create callback
    scrollChatBottom = new CallbackManager("scrollChatBottom");
    // register callbacks
    onScrollChatBottom = (callback: Function) => {
        return this.scrollChatBottom.register(callback);
    }



    /**
     * timer callbacks [CallbackManagerTimer]
     * will expire after the given time
     */

    // create callback
    messageFragment = new CallbackManagerTimer("messageFragment", TIME.ONE_MINUTE, true);
    // register callbacks
    onMessageFragment = (callback: Function) => {
        return this.messageFragment.register(callback);
    }

    // create callback
    // [...Ex] prefix means Extended version
    msgFragmentEx = new CallbackManagerTimerEx("msgFragmentEx", TIME.SEVEN_DAYS, true);
    // register callbacks
    onMsgFragmentEx = (callback: Function, messageNo: number) => {
        return this.msgFragmentEx.register(callback, messageNo);
    }

}

// export Callback class instance (singleton)
export const __callbacks = new Callback();
